import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
export function FinalCTA() {
  return <section className="w-full bg-teal py-24 px-6 flex flex-col items-center justify-center text-center" data-id="element-88">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-89">
        <Logo color="#FFFFFF" size={64} className="mb-12" data-id="element-90" />

        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6" data-id="element-91">
          Tu campo energético sabe
          <br data-id="element-92" />
          lo que todavía no pudiste ver.
        </h2>

        <p className="font-serif italic text-white/90 text-xl md:text-2xl mb-12" data-id="element-93">
          "Cuando estés lista — o listo — acá estoy."
        </p>

        <Link to="/sesiones" className="inline-block bg-gold text-teal font-medium px-12 py-5 rounded-full text-lg hover:bg-white transition-colors duration-300 tracking-wide mb-8 shadow-lg" data-id="element-94">
          QUIERO MI SESIÓN
        </Link>

        <p className="text-white/80 font-light text-sm leading-relaxed" data-id="element-95">
          A distancia · Para cualquier parte del mundo
          <br data-id="element-96" />
          Solo necesitás tu nombre, tu fecha de nacimiento
          <br data-id="element-97" />y lo que querés trabajar.
        </p>
      </motion.div>
    </section>;
}